import { render, staticRenderFns } from "./WarningRateChange.vue?vue&type=template&id=37cca20b&scoped=true&"
import script from "./WarningRateChange.vue?vue&type=script&lang=js&"
export * from "./WarningRateChange.vue?vue&type=script&lang=js&"
import style0 from "./WarningRateChange.vue?vue&type=style&index=0&id=37cca20b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cca20b",
  null
  
)

export default component.exports